import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wage-nontax-compare-yearly-modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "info-row" }
const _hoisted_5 = { class: "info-item" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = { class: "data-badge" }
const _hoisted_10 = { class: "setting-section" }
const _hoisted_11 = { class: "setting-row" }
const _hoisted_12 = { class: "setting-item lunch-setting" }
const _hoisted_13 = { class: "setting-item" }
const _hoisted_14 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_15 = { class: "loading-state" }
const _hoisted_16 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_17 = { class: "monthly-table-wrapper" }
const _hoisted_18 = { class: "monthly-table" }
const _hoisted_19 = { class: "sticky-col" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-right" }
const _hoisted_22 = { class: "before-cell text-right" }
const _hoisted_23 = { class: "before-cell text-right" }
const _hoisted_24 = { class: "before-cell text-right" }
const _hoisted_25 = { class: "after-cell text-right" }
const _hoisted_26 = { class: "after-cell text-right" }
const _hoisted_27 = { class: "after-cell text-right" }
const _hoisted_28 = { class: "total-row" }
const _hoisted_29 = { class: "text-center font-bold" }
const _hoisted_30 = { class: "text-right font-bold" }
const _hoisted_31 = { class: "before-cell text-right font-bold" }
const _hoisted_32 = { class: "before-cell text-right font-bold" }
const _hoisted_33 = { class: "before-cell text-right font-bold" }
const _hoisted_34 = { class: "after-cell text-right font-bold" }
const _hoisted_35 = { class: "after-cell text-right font-bold" }
const _hoisted_36 = { class: "after-cell text-right font-bold" }
const _hoisted_37 = { class: "summary-section" }
const _hoisted_38 = { class: "summary-cards" }
const _hoisted_39 = { class: "summary-card before-card" }
const _hoisted_40 = { class: "summary-row" }
const _hoisted_41 = { class: "value" }
const _hoisted_42 = { class: "summary-row" }
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "summary-row" }
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "summary-row" }
const _hoisted_47 = { class: "value" }
const _hoisted_48 = { class: "summary-card after-card" }
const _hoisted_49 = { class: "summary-row" }
const _hoisted_50 = { class: "value" }
const _hoisted_51 = { class: "summary-row" }
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "summary-row" }
const _hoisted_54 = { class: "value" }
const _hoisted_55 = { class: "summary-row" }
const _hoisted_56 = { class: "value" }
const _hoisted_57 = { class: "summary-card diff-card" }
const _hoisted_58 = { class: "summary-row highlight-row" }
const _hoisted_59 = { class: "value" }
const _hoisted_60 = { class: "summary-row" }
const _hoisted_61 = { class: "summary-row" }
const _hoisted_62 = { class: "summary-row total" }
const _hoisted_63 = { class: "summary-row info" }
const _hoisted_64 = {
  key: 2,
  class: "modal-content empty-state"
}
const _hoisted_65 = { class: "modal-footer" }

import { ref, reactive, computed } from "vue";
import axios from "axios";
import { tokenManager } from "@/services/api";

interface MonthlyData {
  month: number;
  hasData: boolean;
  employeeCount: number;
  totalPay: string;
  before: {
    nonTax: string;
    companyIns: string;
    retirement: string;
  };
  after: {
    nonTax: string;
    companyIns: string;
    retirement: string;
  };
  diff: {
    companyIns: string;
    retirement: string;
  };
  saving: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonWageNontaxCompareYearly',
  props: {
    mCode: {},
    memberName: {},
    bizGubun: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const dialog = ref(false);
const activeTab = ref("monthly");
const loading = ref(false);
const isGeneratingPdf = ref(false);
const selectedYear = ref(new Date().getFullYear());
const monthlyData = ref<MonthlyData[]>([]);
const monthCount = ref(0);
const customLunch = ref("");
const noProductionNontax = ref(false);

const yearlyTotals = reactive({
  totalPay: "0",
  before: {
    nonTax: "0", companyIns: "0", retirement: "0"
  },
  after: {
    nonTax: "0", companyIns: "0", retirement: "0"
  },
  diff: {
    companyIns: "0", retirement: "0"
  },
  saving: "0"
});

const availableYears = computed(() => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear; y >= 2020; y--) {
    years.push(y);
  }
  return years;
});

const hasAnyData = computed(() => {
  return monthlyData.value.some(m => m.hasData);
});

const avgSaving = computed(() => {
  if (monthCount.value === 0) return "0";
  const total = parseFloat(yearlyTotals.saving.replace(/,/g, "")) || 0;
  return Math.round(total / monthCount.value).toLocaleString();
});

const openDialog = () => {
  dialog.value = true;
  activeTab.value = "monthly";
  selectedYear.value = new Date().getFullYear();
  customLunch.value = "";
  noProductionNontax.value = false;
  fetchYearlyData();
};

__expose({ openDialog });

const closeDialog = () => {
  dialog.value = false;
};

const onSettingChange = () => {
  fetchYearlyData();
};

const nc = (value: string | number | null | undefined): number => {
  if (value == null) return 0;
  return parseFloat(value.toString().replace(/,/g, "")) || 0;
};

const getDiffClass = (value: string | undefined, _isReverse = false): string => {
  if (!value) return "";
  const num = nc(value);
  // 차액 = 미적용 - 적용 → 양수가 절감(좋음)
  if (num > 0) return "highlight-green";
  if (num < 0) return "highlight-red";
  return "";
};

const fetchYearlyData = async () => {
  if (!props.mCode) {
    console.warn('시설 코드(m_code)가 없습니다.');
    return;
  }
  
  loading.value = true;
  try {
    const params = new URLSearchParams();
    if (props.bizGubun) {
      params.append('bizGubun', props.bizGubun);
    }
    
    // 설정값 전달
    const inputLunch = parseFloat(customLunch.value.toString().replace(/,/g, "")) || 0;
    if (customLunch.value !== "" && inputLunch >= 0) {
      params.append('customLunch', String(inputLunch));
    }
    if (noProductionNontax.value) {
      params.append('noProductionNontax', '1');
    }
    
    let url = `/api/common-wage/nontax-compare-yearly/${props.mCode}/${selectedYear.value}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const token = tokenManager.getToken();
    const response = await axios.get(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (response.data.success) {
      monthlyData.value = response.data.data.monthlyData;
      monthCount.value = response.data.data.monthCount;
      
      const yt = response.data.data.yearlyTotals;
      yearlyTotals.totalPay = yt.totalPay;
      yearlyTotals.before.nonTax = yt.before.nonTax;
      yearlyTotals.before.companyIns = yt.before.companyIns;
      yearlyTotals.before.retirement = yt.before.retirement;
      yearlyTotals.after.nonTax = yt.after.nonTax;
      yearlyTotals.after.companyIns = yt.after.companyIns;
      yearlyTotals.after.retirement = yt.after.retirement;
      yearlyTotals.diff.companyIns = yt.diff.companyIns;
      yearlyTotals.diff.retirement = yt.diff.retirement;
      yearlyTotals.saving = yt.saving;
    }
  } catch (error: any) {
    console.error("연간 데이터 조회 오류:", error);
    alert("데이터 조회 중 오류가 발생했습니다.");
  } finally {
    loading.value = false;
  }
};

const generatePdf = async () => {
  if (!hasAnyData.value) {
    alert("데이터가 없습니다.");
    return;
  }

  isGeneratingPdf.value = true;
  try {
    const token = tokenManager.getToken();
    const response = await axios.post("/api/common-wage/nontax-compare-yearly-pdf", {
      monthlyData: monthlyData.value,
      yearlyTotals: {
        totalPay: yearlyTotals.totalPay,
        before: yearlyTotals.before,
        after: yearlyTotals.after,
        diff: yearlyTotals.diff,
        saving: yearlyTotals.saving
      },
      memberName: props.memberName || "기관명",
      year: selectedYear.value
    }, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });

    if (response.data.success) {
      const pdfBase64 = response.data.pdf;
      const binaryString = window.atob(pdfBase64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (!newWindow) {
        alert("팝업 차단 설정을 확인해주세요.");
      }
    } else {
      alert("PDF 생성 실패: " + (response.data.message || "알 수 없는 오류"));
    }
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || "알 수 없는 오류";
    alert("PDF 생성 중 오류: " + message);
    console.error("PDF 생성 오류:", error);
  } finally {
    isGeneratingPdf.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialog).value = $event)),
    "max-width": "1600px",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", null, "임금개선 분석 보고서 (1년치)", -1)),
          _createVNode(_component_v_icon, {
            class: "close-btn",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "info-label" }, "조회 연도", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedYear).value = $event)),
                class: "year-select",
                onChange: fetchYearlyData
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (year) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: year,
                    value: year
                  }, _toDisplayString(year) + "년", 9, _hoisted_6))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedYear.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "info-label" }, "데이터 현황", -1)),
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(monthCount.value) + "개월 데이터 보유", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "setting-title" }, "비과세 미적용 시나리오 설정", -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "setting-label" }, "중식비 금액 (전 직원 동일 적용)", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: customLunch.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customLunch).value = $event)),
                type: "text",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                class: "lunch-input",
                placeholder: "0",
                onInput: onSettingChange
              }, null, 8, ["modelValue"]),
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "setting-hint" }, "※ 현재 중식비가 더 작으면 현재 금액 유지", -1))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_v_checkbox, {
                modelValue: noProductionNontax.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((noProductionNontax).value = $event)),
                label: "생산직 비과세 모두 미적용 (연장/야간/휴일 수당 비과세 제외)",
                "hide-details": "",
                density: "compact",
                color: "primary",
                onChange: onSettingChange
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "primary"
                }),
                _cache[13] || (_cache[13] = _createElementVNode("p", null, "데이터를 불러오는 중...", -1))
              ])
            ]))
          : (hasAnyData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_v_tabs, {
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event)),
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: "monthly" }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("월별 상세", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "summary" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("연간 요약", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_window, {
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeTab).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: "monthly" }, {
                      default: _withCtx(() => [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "unit-label" }, "단위: 원", -1)),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("table", _hoisted_18, [
                            _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", { class: "sticky-col" }, "월"),
                                _createElementVNode("th", null, "대상 인원"),
                                _createElementVNode("th", null, "총급여"),
                                _createElementVNode("th", { class: "before-header" }, "미적용 비과세"),
                                _createElementVNode("th", { class: "before-header" }, "미적용 기관부담"),
                                _createElementVNode("th", { class: "before-header" }, "미적용 퇴직금"),
                                _createElementVNode("th", { class: "after-header" }, "적용 비과세"),
                                _createElementVNode("th", { class: "after-header" }, "적용 기관부담"),
                                _createElementVNode("th", { class: "after-header" }, "적용 퇴직금"),
                                _createElementVNode("th", { class: "diff-header" }, "기관부담 차액(미적용-적용(현재))"),
                                _createElementVNode("th", { class: "diff-header" }, "퇴직금 차액(미적용-적용(현재))"),
                                _createElementVNode("th", { class: "saving-header" }, "월 절감액")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlyData.value, (monthData) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: monthData.month,
                                  class: _normalizeClass({ 'no-data-row': !monthData.hasData })
                                }, [
                                  _createElementVNode("td", _hoisted_19, _toDisplayString(monthData.month) + "월", 1),
                                  _createElementVNode("td", _hoisted_20, _toDisplayString(monthData.hasData ? monthData.employeeCount + '명' : '-'), 1),
                                  _createElementVNode("td", _hoisted_21, _toDisplayString(monthData.hasData ? monthData.totalPay : '-'), 1),
                                  _createElementVNode("td", _hoisted_22, _toDisplayString(monthData.hasData ? monthData.before.nonTax : '-'), 1),
                                  _createElementVNode("td", _hoisted_23, _toDisplayString(monthData.hasData ? monthData.before.companyIns : '-'), 1),
                                  _createElementVNode("td", _hoisted_24, _toDisplayString(monthData.hasData ? monthData.before.retirement : '-'), 1),
                                  _createElementVNode("td", _hoisted_25, _toDisplayString(monthData.hasData ? monthData.after.nonTax : '-'), 1),
                                  _createElementVNode("td", _hoisted_26, _toDisplayString(monthData.hasData ? monthData.after.companyIns : '-'), 1),
                                  _createElementVNode("td", _hoisted_27, _toDisplayString(monthData.hasData ? monthData.after.retirement : '-'), 1),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["diff-cell text-right", getDiffClass(monthData.diff?.companyIns, true)])
                                  }, _toDisplayString(monthData.hasData ? monthData.diff.companyIns : '-'), 3),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["diff-cell text-right", getDiffClass(monthData.diff?.retirement, true)])
                                  }, _toDisplayString(monthData.hasData ? monthData.diff.retirement : '-'), 3),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["saving-cell text-right font-bold", getDiffClass(monthData.saving, true)])
                                  }, _toDisplayString(monthData.hasData ? monthData.saving : '-'), 3)
                                ], 2))
                              }), 128))
                            ]),
                            _createElementVNode("tfoot", null, [
                              _createElementVNode("tr", _hoisted_28, [
                                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "sticky-col font-bold" }, "연간 합계", -1)),
                                _createElementVNode("td", _hoisted_29, _toDisplayString(monthCount.value) + "개월", 1),
                                _createElementVNode("td", _hoisted_30, _toDisplayString(yearlyTotals.totalPay), 1),
                                _createElementVNode("td", _hoisted_31, _toDisplayString(yearlyTotals.before.nonTax), 1),
                                _createElementVNode("td", _hoisted_32, _toDisplayString(yearlyTotals.before.companyIns), 1),
                                _createElementVNode("td", _hoisted_33, _toDisplayString(yearlyTotals.before.retirement), 1),
                                _createElementVNode("td", _hoisted_34, _toDisplayString(yearlyTotals.after.nonTax), 1),
                                _createElementVNode("td", _hoisted_35, _toDisplayString(yearlyTotals.after.companyIns), 1),
                                _createElementVNode("td", _hoisted_36, _toDisplayString(yearlyTotals.after.retirement), 1),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(yearlyTotals.diff.companyIns, true)])
                                }, _toDisplayString(yearlyTotals.diff.companyIns), 3),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(yearlyTotals.diff.retirement, true)])
                                }, _toDisplayString(yearlyTotals.diff.retirement), 3),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["saving-cell text-right font-bold", getDiffClass(yearlyTotals.saving, true)])
                                }, _toDisplayString(yearlyTotals.saving), 3)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "summary" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _cache[23] || (_cache[23] = _createElementVNode("h3", null, "비과세 미적용", -1)),
                              _createElementVNode("div", _hoisted_40, [
                                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "연간 총급여", -1)),
                                _createElementVNode("span", _hoisted_41, _toDisplayString(yearlyTotals.totalPay), 1)
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "연간 비과세", -1)),
                                _createElementVNode("span", _hoisted_43, _toDisplayString(yearlyTotals.before.nonTax), 1)
                              ]),
                              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "divider" }, null, -1)),
                              _createElementVNode("div", _hoisted_44, [
                                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "연간 기관부담 4대보험", -1)),
                                _createElementVNode("span", _hoisted_45, _toDisplayString(yearlyTotals.before.companyIns), 1)
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "연간 퇴직금", -1)),
                                _createElementVNode("span", _hoisted_47, _toDisplayString(yearlyTotals.before.retirement), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _cache[29] || (_cache[29] = _createElementVNode("h3", null, "비과세 적용 (현재)", -1)),
                              _createElementVNode("div", _hoisted_49, [
                                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "연간 총급여", -1)),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(yearlyTotals.totalPay), 1)
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "연간 비과세", -1)),
                                _createElementVNode("span", _hoisted_52, _toDisplayString(yearlyTotals.after.nonTax), 1)
                              ]),
                              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "divider" }, null, -1)),
                              _createElementVNode("div", _hoisted_53, [
                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "연간 기관부담 4대보험", -1)),
                                _createElementVNode("span", _hoisted_54, _toDisplayString(yearlyTotals.after.companyIns), 1)
                              ]),
                              _createElementVNode("div", _hoisted_55, [
                                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "연간 퇴직금", -1)),
                                _createElementVNode("span", _hoisted_56, _toDisplayString(yearlyTotals.after.retirement), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _cache[36] || (_cache[36] = _createElementVNode("h3", null, "연간 기관 비용 절감 효과", -1)),
                              _createElementVNode("div", _hoisted_58, [
                                _cache[31] || (_cache[31] = _createElementVNode("span", { class: "label" }, "데이터 보유 기간", -1)),
                                _createElementVNode("span", _hoisted_59, _toDisplayString(monthCount.value) + "개월", 1)
                              ]),
                              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "divider" }, null, -1)),
                              _createElementVNode("div", _hoisted_60, [
                                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "기관부담 4대보험 차액", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["value", getDiffClass(yearlyTotals.diff.companyIns, true)])
                                }, _toDisplayString(yearlyTotals.diff.companyIns), 3)
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "퇴직금 차액", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["value", getDiffClass(yearlyTotals.diff.retirement, true)])
                                }, _toDisplayString(yearlyTotals.diff.retirement), 3)
                              ]),
                              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "divider" }, null, -1)),
                              _createElementVNode("div", _hoisted_62, [
                                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "연간 절감액", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["value large", getDiffClass(yearlyTotals.saving, true)])
                                }, _toDisplayString(yearlyTotals.saving), 3)
                              ]),
                              _createElementVNode("div", _hoisted_63, [
                                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "월 평균 절감액", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["value", getDiffClass(yearlyTotals.saving, true)])
                                }, _toDisplayString(avgSaving.value), 3)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                _createElementVNode("p", null, _toDisplayString(selectedYear.value) + "년 데이터가 없습니다.", 1)
              ])),
        _createElementVNode("div", _hoisted_65, [
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-search",
            onClick: generatePdf,
            disabled: !hasAnyData.value,
            loading: isGeneratingPdf.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                left: "",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                  _createTextVNode("mdi-file-pdf-box", -1)
                ]))]),
                _: 1
              }),
              _cache[40] || (_cache[40] = _createTextVNode(" PDF 출력 ", -1))
            ]),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-cancel",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
              _createTextVNode("닫기", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})